import { numberOrZero } from "@/utils/utils";
import { Popover } from "antd";
import { useTranslation } from "react-i18next";
import { formatLocaleCurrency } from "../../../../../../common/utils/formatUtils";
import { DashboardGoal } from "../../../../types";
import { getPercentage } from "../../../../utils";
import { GoalCard } from "../cards/GoalCard";

type Props = {
  goal: DashboardGoal;
  year: number;
  agentId: string;
};

export const BrokerCommissionsWrapper = ({ goal, agentId, year }: Props) => {
  const { t } = useTranslation();

  const actualValue = numberOrZero(goal.actualValue);
  const targetValue = numberOrZero(goal.targetValue);

  const currentPercentage = getPercentage(actualValue, targetValue);

  return (
    <GoalCard
      isGaugeStyle
      agentId={agentId}
      year={year}
      goal={goal}
      percentage={currentPercentage}
      tooltipTitle={
        <p>
          {formatLocaleCurrency(actualValue, 0)} {t("dashboard.goals.helpers.from")}{" "}
          {formatLocaleCurrency(targetValue, 0)}
        </p>
      }
      label={
        <Popover content={t("dashboard.goals.helpers.commissionsGoalHint")}>
          {t("dashboard.enums.dashboardGoalType.BROKER_COMMISSIONS")}
        </Popover>
      }
      hasTarget
    />
  );
};
